import { Fab, ListItemIcon, ListItemText } from "@material-ui/core";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import React from "react";


type MenuFabProps = {
    label: string
    icon: JSX.Element
    options: [label: string, icon: JSX.Element, onClick: () => void][]
    size?: "small"
    color: "primary" | "secondary"
    FabStyle?: React.CSSProperties
}

export function MenuFab({ label, icon, options, size, color, FabStyle }: MenuFabProps) {
    return (
        <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
                <React.Fragment>
                    <Fab
                        style={FabStyle}
                        size={size}
                        color={color}
                        aria-label={label}
                        {...bindTrigger(popupState)}
                    >
                        {icon}
                    </Fab>
                    <Menu {...bindMenu(popupState)}>
                        {options.map(([optionLabel, optionIcon, optionOnClick]) => (
                            <MenuItem key={optionLabel} onClick={() => {
                                popupState.close()
                                optionOnClick()
                            }}>
                                <ListItemIcon>
                                    {optionIcon}
                                </ListItemIcon>
                                <ListItemText primary={optionLabel} />
                            </MenuItem>
                        ))}
                    </Menu>
                </React.Fragment>
            )}
        </PopupState>
    )
}